<!-- Base.FileChipList.vue (client-lms) -->
<template>
  <div class="lms_file_chip_list">
    <!-- 기존 업로드 완료 파일 (Edit 모드) -->
    <div v-for="f in existing" :key="'ex_' + f.fileId" class="lms_file_chip">
      <!-- <i class="mdi" :class="fileIconByExt(f.ext)" style="font-size: 20px; color: #5C74F6;"></i> -->
      <span class="lms_file_chip_name">{{ f.originalName }}</span>
      <span class="lms_file_chip_size">{{ formatFileSize(f.volume) }}</span>
      <a
        v-if="downloadable"
        :href="existingHref(f)"
        :download="f.originalName"
        class="lms_file_chip_action"
      >
        <i class="mdi mdi-download-outline"></i>
      </a>
      <i
        v-if="removable"
        class="mdi mdi-close-circle lms_file_chip_action"
        @click="$emit('remove-existing', f.fileId)"
      ></i>
    </div>
    <!-- 신규 업로드 File 객체 -->
    <div v-for="(file, i) in files" :key="i" class="lms_file_chip">
      <!-- <i class="mdi" :class="fileIcon(file.name)" style="font-size: 20px; color: #5C74F6;"></i> -->
      <span class="lms_file_chip_name">{{ file.name }}</span>
      <span class="lms_file_chip_size">{{ formatFileSize(file.size) }}</span>
      <i v-if="downloadable" class="mdi mdi-download-outline lms_file_chip_action" @click="onDownload(file)"></i>
      <i v-if="removable" class="mdi mdi-close-circle lms_file_chip_action" @click="$emit('remove', i)"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatFileSize, getFileExt } from "@/common/js/fileUtil";
import type { ExistingFile } from "@/types/lms/CourseLessonType";

defineProps({
  files: { type: Array as () => File[], default: () => [] },
  existing: { type: Array as () => ExistingFile[], default: () => [] },
  downloadable: { type: Boolean, default: true },
  removable: { type: Boolean, default: true },
});

const emit = defineEmits<{
  (e: "remove", index: number): void;
  (e: "remove-existing", fileId: string): void;
  (e: "download", file: File): void;
}>();

// const fileIconByExt = (ext: string) => {
//   const e = (ext ?? "").toLowerCase();
//   if (["mp4", "mov", "avi"].includes(e)) return "mdi-file-video-outline";
//   if (["jpg", "jpeg", "png", "gif"].includes(e)) return "mdi-file-image-outline";
//   if (["zip", "rar", "7z"].includes(e)) return "mdi-zip-box-outline";
//   return "mdi-file-document-outline";
// };

const existingHref = (f: ExistingFile): string => (f.link ?? "") + (f.saveName ?? "");

// const fileIcon = (name: string) => {
//   const ext = getFileExt(name);
//   if (["mp4", "mov", "avi"].includes(ext)) return "mdi-file-video-outline";
//   if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "mdi-file-image-outline";
//   if (["zip", "rar", "7z"].includes(ext)) return "mdi-zip-box-outline";
//   return null;
// };

const onDownload = (file: File) => {
  emit("download", file);
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
};
</script>
